import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        title: 'Login',
        requiresAuth: false,
        layout: 'full',
      },
    },
    {
      path: '/password/reset',
      name: 'reset',
      component: () => import('@/views/ResetPassword-v1.vue'),
      meta: {
        title: 'Reset',
        requiresAuth: false,
        layout: 'full',
      },
    },
    {
      path: '/password/forgot',
      name: 'forgot',
      component: () => import('@/views/ForgotPassword-v1.vue'),
      meta: {
        title: 'Forgot',
        requiresAuth: false,
        layout: 'full',
      },
    },
    {
      path: '/files/:id?',
      name: 'files',
      component: () => import('@/views/FilesPage.vue'),
      meta: {
        resource: 'object',
        title: 'Files',
        requiresAuth: true,
        pageTitle: 'Files',
        breadcrumb: [
          {
            text: 'Files',
            active: true,
          },
        ],
      },
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/User.vue'),
      meta: {
        resource: 'object',
        title: 'User',
        pageTitle: 'User',
        // layout: 'full',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'User',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reports/deleted',
      name: 'deleted-report',
      component: () => import('@/views/reports/DeletedReport.vue'),
      meta: {
        title: 'Report cartelle eliminate',
        pageTitle: 'Report cartelle eliminate',
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Report',
          },
          {
            text: 'Cartelle eliminate',
            active: true,
          },
        ],
      },
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: () => import('@/views/NotAuthorized.vue'),
      meta: {
        title: 'forbidden',
        pageTitle: 'Vietato',
        // layout: 'full',
        requiresAuth: true,
        breadcrumb: [
        ],
      },
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/FilesPage.vue'),
      meta: {
        resource: 'object',
        pageTitle: 'Test',
        breadcrumb: [
          {
            text: 'Test',
            active: true,
          },
        ],
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        title: 'Error | 404',
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: '/files',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
